import { render } from "./linux-repair-wrapper.vue?vue&type=template&id=62727701&scoped=true&ts=true"
import script from "./linux-repair-wrapper.vue?vue&type=script&lang=ts"
export * from "./linux-repair-wrapper.vue?vue&type=script&lang=ts"

import "./linux-repair-wrapper.vue?vue&type=style&index=0&id=62727701&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62727701"]])

export default __exports__